import { createContext, useContext } from 'react';
import { GripVertical } from 'lucide-react';

// Context for drag listeners
export const DragListenersContext = createContext(null);

// Hook to use drag listeners inside a sortable item
export const useDragListeners = () => {
  const context = useContext(DragListenersContext);
  if (!context) {
    throw new Error('useDragListeners must be used within SortableGridItem');
  }
  return context;
};

// Drag Handle Button Component
export const DragHandle = () => {
  const { listeners, attributes } = useDragListeners();

  return (
    <div
      {...listeners}
      {...attributes.listeners}
      className="cursor-grab active:cursor-grabbing p-1 hover:bg-secondary rounded md:opacity-0 group-hover:opacity-100 transition-opacity"
      title="Drag to reorder"
    >
      <GripVertical className="h-4 w-4 text-primary" />
    </div>
  );
};
